import { useEffect, useRef } from 'react';
import axiosInstance from '../general/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../general/actions';

const Logout = ({ isLoggedIn, logout }) => {
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (!isLoggedIn && !started.current) {
      navigate('/login', { replace: true });
      return;
    }
    if (started.current) return;
    started.current = true;

    axiosInstance.post('/logout')
      .catch((error) => console.log(error))
      .finally(() => {
        logout();
        // Solo claves de UI (sin credenciales); se limpian las propias de la sesión.
        try { localStorage.removeItem('count_pending_approve'); localStorage.removeItem('selectedAgreement'); } catch (e) {}
        navigate('/login', { replace: true });
      });
  }, [isLoggedIn, logout, navigate]);

  return (
    <div className="auth-page">
      <div style={{ color: 'var(--abi-muted)', fontSize: 14 }}>
        <i className="fa fa-circle-o-notch fa-spin" /> Cerrando sesión…
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ isLoggedIn: state.isLoggedIn });

export default connect(mapStateToProps, { logout })(Logout);
